<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <section
      v-scroll-lock="true"
      class="modal active"
    >
      <div class="modal-overlay" />

      <section class="modal-container modal-form modal-form--lg form-new-card">
        <header class="modal-header modal-form__header">
          <a
            class="btn btn-clear float-right modal-form__close"
            aria-label="close"
            @click="close"
          />

          <h1 class="modal-form__title mb-0">
            Cadastrar novo cartão
          </h1>
        </header>

        <article class="modal-body modal-form__body mt-0 pt-0">
          <div
            :class="{ 'cursor-not-allowed': ui.isLoading }"
            class="form-new-card__wrapper"
          >
            <credit-card-new
              :class="{ 'pointer-events-none': ui.isLoading }"
              v-model="card"
            />

            <div
              :class="{ 'pointer-events-none': ui.isLoading }"
              class="mt-1 flex flex-row items-center justify-start"
            >
              <label class="!my-0 !py-0 normal-case text-sm form-checkbox">
                <input
                  v-model="ui.isDefault"
                  type="checkbox"
                  class=""
                >

                <i class="form-icon" />

                <span class="mt-0 block flex items-center">
                  Definir cartão como padrão
                </span>
              </label>
            </div>
          </div>
        </article>

        <footer class="modal-form__footer flex flex-row items-center justify-end mb-0 px-2">
          <button
            :disabled="!card.isValid || ui.isLoading"
            class="btn btn-primary"
            @click="saveCard"
          >
            Cadastrar cartão
          </button>
        </footer>
      </section>
    </section>
  </transition>
</template>

<script>
import creditCardNew from './creditCardNew'

export default {
  name: 'NewCreditCardModal',

  components: {
    creditCardNew
  },

  data () {
    return {
      card: {},
      ui: {
        isLoading: false,
        isDefault: false
      }
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },

    saveCard () {
      if (this.card.isValid) {
        const data = { ...this.card }
        delete data.isValid
        delete data.id
        data.isDefault = Number(this.ui.isDefault)
        data.expirationDate = data.expirationDate.replace(/\D/, '')

        this.ui.isLoading = true
        this.fn_SHOW_PROGRESS()
        this.$http
          .post(
            '/user/credit_card',
            { 'credit_card': data },
            this.$store.getters.getAuthHeader
          )
          .then(() => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Cartão adicionado com sucesso.',
              size: 'md',
              active: true
            })

            this.close()

            this.$emit('update')
          })
          .catch((err) => this.fn_HANDLE_ERROR(err))
          .finally(() => {
            this.ui.isLoading = false
            this.fn_HIDE_PROGRESS()
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-new-card {
  width: 40rem;

  &__wrapper {
    @apply p-3 rounded rounded-lg;
    background: #f4f4f4;
  }
}
</style>
